function clean(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i];
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
        if (typeof obj[propName] === 'object') {
            clean(obj[propName]);
        }
    }
}

export function loadState() {
    try {
        const serializedState = localStorage.getItem('currentReport');
        if (serializedState === null) {
            return null;
        }
        return clean(JSON.parse(serializedState));
    } catch (err) {
        console.warn('localStorage not available');
        return null;
    }
}

export function saveState(state, dispatch) {
    try {
        localStorage.setItem('currentReport', JSON.stringify(state));
    } catch (err) {
        console.warn('localStorage not available');
    }
}



// WEBPACK FOOTER //
// ./src/store/localStorage.ts